import React, { useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment'
import { CommonApiFun } from '../../Redux/Action/index'
import { useNavigate } from 'react-router-dom';
import {routes} from '../../MainPage'
// import svg from '../../../../../img/symbol.svg'
function OurNews(props) {
    const dispatch = useDispatch()
    const navigate=useNavigate()
    var blogArr = useSelector((state) => state.blogArr)
    
    useEffect(() => {
       
            var data = { action: "blogs" }

            dispatch(CommonApiFun("api/Api_controller/post", JSON.stringify(data))).then((res) => {
              
                dispatch({ type: 'BLOGS_DATA', payload: res.data })

            }).catch((e) => {
                
            })

    }, [])

    const slides = [];
    blogArr.forEach((item, idx) => {
        if(idx<3){
        slides.push(
            <SwiperSlide className=" news_item" key={idx}>
                <div className="news_inner" onClick={()=> navigate(routes.blog + '/info', { state: item })}>
                    <a href="javascript:void(0)">
                    <img src={item.image}  />
                    </a>
                    {/* <span className="article-date">AUG 9 | CEO</span> */}
                    <span className="article-date">{moment(item.created_date).format("MMM Do YY")}</span>
                    <h5>
                    {item.title}
                    </h5>
                   
                </div>
            </SwiperSlide>
        );
        }
    });
    return (
        <div className="web-sect">
            <div className="news-bg pad-60">
                <div className="container">
                    <div className="title-box title_btn">
                        <span className="title_span">
                        <span className="subtitle">Our Latest Research</span><h3 className="text-center">Our Articles</h3>
                        </span>
                        <button className="btn text-center" onClick={() => { navigate(routes.blog) }}>View All</button></div>
                    <div className="row news-wrapper">
                        <Swiper className="news_wrap" spaceBetween={0}
                            modules={[Navigation, Pagination, Scrollbar, A11y]}
                            slidesPerView={3}
                            effect={"slide"}
                            //  Pagination
                            pagination={{
                                el: ".swiper-pagination",
                                clickable: true,
                            }}
                            breakpoints={{
                                320: {
                                    slidesPerView: 1,
                                },
                                576: {
                                    slidesPerView: 2,
                                },
                                768: {
                                    slidesPerView: 3,
                                },
                            }}>
                            {slides}
                            <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OurNews;